// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SendRequestModel {
    static getAttributeTypeMap() {
        return SendRequestModel.attributeTypeMap;
    }
}
SendRequestModel.discriminator = undefined;
SendRequestModel.attributeTypeMap = [
    {
        "name": "email",
        "baseName": "email",
        "type": "EmailSendEmailSingle"
    },
    {
        "name": "check",
        "baseName": "check",
        "type": "boolean"
    }
];
//# sourceMappingURL=sendRequestModel.js.map